var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcstaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8109 0H-0.000421047V8.37793L13.8109 20.3881V0Z",
    fill: "#90BBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 12.8246C28.9375 17.0017 25.5513 20.3879 21.3742 20.3879C17.1971 20.3879 13.8109 17.0017 13.8109 12.8246C13.8109 8.64744 17.1971 5.26123 21.3742 5.26123C25.5513 5.26123 28.9375 8.64744 28.9375 12.8246ZM18.7054 12.8246C18.7054 14.2985 19.9002 15.4934 21.3742 15.4934C22.8481 15.4934 24.043 14.2985 24.043 12.8246C24.043 11.3506 22.8481 10.1557 21.3742 10.1557C19.9002 10.1557 18.7054 11.3506 18.7054 12.8246Z",
    fill: "#548BD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcstaker);
export default __webpack_public_path__ + "static/media/btcstaker.1e74ce1657f5f2c6a1828d2bd15f6909.svg";
export { ForwardRef as ReactComponent };